// extracted by mini-css-extract-plugin
export default {"wrapper":"xRDhhrQ","title":"eP3dTTH","desc":"sHRex9k","image":"EKEx270","icon":"VUPKnEr","actions":"VBKMZEd"};